import {
  POST_NEW_ONBOARD_REQUEST,
  POST_NEW_ONBOARD_INVITE_REQUEST,
  GET_ONBOARD_DETAILS,
  GET_ONBOARD_TIMELINE_EVENTS,
  GET_ONBOARD_REQUESTS,
  DELETE_ONBOARD_REQUEST,
  PUT_UPDATE_ONBOARD_REQUEST,
  PUT_REASSIGN_ONBOARD_REQUEST,
  POST_REQUEST_PAYMENT,
  POST_ONBOARD_REQUEST_SIGNUP,
  POST_REQUEST_NDA_SIGNATURE,
  POST_REQUEST_CONTRACT_SIGNATURE,
  POST_SIGN_UP_ONBOARD_REQUEST_PHASE_3,
  POST_NEW_ONBOARD_REQUEST_MESSAGE,
  POST_NEW_ONBOARD_REVIEW_REQUEST,
  POST_SEND_REQUEST_INVOICE,
  POST_RESPOND_ONBOARD_REVIEW_REQUEST,
  PUT_UPDATE_ONBOARD_REQUEST_INFO,
  GET_ONBOARD_REQUEST_FILES,
  GET_ONBOARD_REQUEST_INFO,
  DELETE_ONBOARD_REQUEST_MESSAGE,
  DELETE_ONBOARD_REQUEST_FILE
} from '@/services/requests'

const postNewOnboardRequest = (context, data) => {
  return POST_NEW_ONBOARD_REQUEST(data)
}

const postNewOnboardInviteRequest = (context, data) => {
  return POST_NEW_ONBOARD_INVITE_REQUEST(data)
}

const postNewOnboardRequestMessage = (context, data) => {
  return POST_NEW_ONBOARD_REQUEST_MESSAGE(data)
}

const deleteOnboardRequestMessage = (context, payload) => {
  return DELETE_ONBOARD_REQUEST_MESSAGE(payload)
}

const deleteOnboardRequestFile = (context, payload) => {
  return DELETE_ONBOARD_REQUEST_FILE(payload)
}

const postNewOnboardReviewRequest = (context, data) => {
  return POST_NEW_ONBOARD_REVIEW_REQUEST(data)
}

const postRespondOnboardReviewRequest = (context, data) => {
  return POST_RESPOND_ONBOARD_REVIEW_REQUEST(data)
}

const postRequestNDASignature = (context, data) => {
  return POST_REQUEST_NDA_SIGNATURE(data)
}

const postRequestContractSignature = (context, data) => {
  return POST_REQUEST_CONTRACT_SIGNATURE(data)
}

const postSendRequestInvoice = (context, data) => {
  return POST_SEND_REQUEST_INVOICE(data)
}

const postRequestPayment = (context, data) => {
  return POST_REQUEST_PAYMENT(data)
}

const deleteOnboardRequest = (context, requestId) => {
  return DELETE_ONBOARD_REQUEST(requestId)
}

const postSignUpOnboardRequestPhase3 = (_, data) => {
  return POST_SIGN_UP_ONBOARD_REQUEST_PHASE_3(data)
}

const putUpdateOnboardRequestInfo = (_, data) => {
  return PUT_UPDATE_ONBOARD_REQUEST_INFO(data)
}

const putReassignOnboardRequest = (_, data) => {
  return PUT_REASSIGN_ONBOARD_REQUEST(data)
}

const putUpdateOnboardRequest = (context, data) => {
  return PUT_UPDATE_ONBOARD_REQUEST(data)
}

const postOnboardRequestSignup = (context, data) => {
  return POST_ONBOARD_REQUEST_SIGNUP(data)
}

const getOnboardRequestInfo = (_, requestId) => {
  return GET_ONBOARD_REQUEST_INFO(requestId)
}

const getOnboardRequestFiles = (_, requestId) => {
  return GET_ONBOARD_REQUEST_FILES(requestId)
}

const getOnboardRequestDetails = (context, requestId) => {
  return GET_ONBOARD_DETAILS(requestId)
}

const getOnboardRequestTimelineEvents = (context, requestId) => {
  return GET_ONBOARD_TIMELINE_EVENTS(requestId)
}

const getOnboardRequests = () => {
  return GET_ONBOARD_REQUESTS()
}

export default {
  postNewOnboardRequest,
  postNewOnboardInviteRequest,
  postRespondOnboardReviewRequest,
  postNewOnboardRequestMessage,
  getOnboardRequestDetails,
  getOnboardRequestInfo,
  getOnboardRequestFiles,
  getOnboardRequestTimelineEvents,
  getOnboardRequests,
  putUpdateOnboardRequest,
  putUpdateOnboardRequestInfo,
  putReassignOnboardRequest,
  postRequestNDASignature,
  postRequestContractSignature,
  postRequestPayment,
  postSendRequestInvoice,
  postOnboardRequestSignup,
  postNewOnboardReviewRequest,
  postSignUpOnboardRequestPhase3,
  deleteOnboardRequest,
  deleteOnboardRequestMessage,
  deleteOnboardRequestFile
}
